// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__1v9Fy","header":"MessagesList_header__7JXHu","chat":"MessagesList_chat__1KGjB"};